<template>
	<section class="m-table" id="m-table" :class="{'z-v_hidden': showTable}">
        <table id="table-new">
            <thead>
                <tr f-font-PFR s-cr="#999999" class="g-fs28 f-nowrap">
                    <th><div>指数名称</div></th>
                    <th v-for="item in tableHead" :key="item.name">
                        <div class="m-head-rank">
                            {{item.name}}
                            <div class="m-rank-base"></div>
                        </div>
                        <!-- <div class="m-head-rank" :class="{'m-head-up': item.status === '2', 'm-head-down': item.status === '1'}">{{item.name}}</div> -->
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr 
                    v-for="(item, index) in currentList" 
                    :key="index" 
                    :class="{'low-color': item.evaluateStatus === '0', 'middle-color': item.evaluateStatus === '1', 'high-color': item.evaluateStatus === '2'}"
                >
                    <td>
                        <div class="m-tbody-td">
                            <div class="m-tbody-td-first f-ellipsis">{{item.name || item.fundName || '--'}}</div>
                            <div f-font-PFR s-cr="#666666" class="g-fs24 m-tbody-td-second">
                                <span s-cr="#FFFFFF" v-if="item.evaluateStatus" class="specical-color">{{status[item.evaluateStatus]}}</span>{{item.fundCode}}
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="m-tbody-td">
                            <div class="m-tbody-td-first">{{item.type}}</div>
                            <div class="m-tbody-td-second"></div>
                        </div>
                    </td>
                    <td>
                        <div class="m-tbody-td">
                            <div class="m-tbody-td-first">{{item.pe | formatProfit(false, false, true)}}</div>
                            <div f-font-PFR s-cr="#666666" class="g-fs24 m-tbody-td-second f-tc m-suit" v-if="item.applyArea === 'PE'">适用</div>
                            <div class="m-tbody-td-second" v-else></div>
                        </div>
                    </td>
                    <td>
                        <div class="m-tbody-td">
                            <div class="m-tbody-td-first">{{item.pePercent | formatProfit(true, false, true)}}</div>
                            <div class="m-tbody-td-second">
                                <span class="m-table-progress">
                                    <em 
                                    :style="{width: `${item.pePercent}%`}"
                                    :class="{'low-color-em': item.pePercent <= 30, 'middle-color-em': item.pePercent > 30 && item.pePercent <= 70, 'high-color-em': item.pePercent > 70 && item.pePercent <= 100}">
                                    </em>
                                </span>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="m-tbody-td">
                            <div class="m-tbody-td-first">{{item.pb | formatProfit(false, false, true)}}</div>
                            <div f-font-PFR s-cr="#666666" class="g-fs24 m-tbody-td-second f-tc m-suit" v-if="item.applyArea === 'PB'">适用</div>
                            <div class="m-tbody-td-second" v-else></div>
                        </div>
                    </td>
                    <td>
                        <div class="m-tbody-td">
                            <div class="m-tbody-td-first">{{item.pbPercent | formatProfit(true, false, true)}}</div>
                            <div class="m-tbody-td-second">
                                <span class="m-table-progress">
                                    <em 
                                    :style="{width: `${item.pbPercent}%`}"
                                    :class="{'low-color-em': item.pbPercent <= 30, 'middle-color-em': item.pbPercent > 30 && item.pbPercent <= 70, 'high-color-em': item.pbPercent > 70 && item.pbPercent <= 100}">
                                    </em>
                                </span>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="m-tbody-td">
                            <div class="m-tbody-td-first">{{item.roe | formatProfit(true, false, true)}}</div>
                            <div class="m-tbody-td-second"></div>
                        </div>
                    </td>
                    <td>
                        <div class="m-tbody-td">
                            <div class="m-tbody-td-first" :class="{red: item.weekRise > 0, green: item.weekRise < 0}">{{item.weekRise | formatProfit(true, true, true)}}</div>
                            <div class="m-tbody-td-second"></div>
                        </div>
                    </td>
                    <td>
                        <div class="m-tbody-td">
                            <div class="m-tbody-td-first" :class="{red: item.nowYearRise > 0, green: item.nowYearRise < 0}">{{item.nowYearRise | formatProfit(true, true, true)}}</div>
                            <div class="m-tbody-td-second"></div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
	</section>
</template>

<script>
    export default {
        name: "table",
        props: {
            initAllMeList: {
                type: Array,
                default: () => []
            },
            control: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                tableHead: [{
                    name: '类型',
                    status: '0',
                    type: 'type'
                }, {
                    name: 'PE',
                    status: '0',
                    type: 'newpe'
                }, {
                    name: 'PE百分位',
                    status: '0',
                    type: 'pepercent'
                }, {
                    name: 'PB',
                    status: '0',
                    type: 'newpb'
                }, {
                    name: 'PB百分位',
                    status: '0',
                    type: 'pbpercent'
                }, {
                    name: 'ROE',
                    status: '0',
                    type: 'newroe'
                }, {
                    name: '近一周涨幅',
                    status: '0',
                    type: 'weekzhangfu'
                }, {
                    name: '今年来涨幅',
                    status: '0',
                    type: 'yearzhangfu'
                }],
                status: {
                    '0': '较低',
                    '1': '适中',
                    '2': '较高'
                },
                currentList: [],
                showTable: true,
			}
        },
        methods: {
        },
        mounted() {
            this.currentList = [...this.initAllMeList];
            this.$nextTick(() => {
                let otablewrapper = document.getElementById('m-table');
                let otable = document.getElementById('table-new');
                let rate = otablewrapper.offsetWidth / otable.offsetWidth;
                let ewidth, eheight, aheight;
                aheight = otable.offsetHeight;
                ewidth = otable.offsetWidth * (1-rate) / (2 * rate);
                eheight = otable.offsetHeight * (1-rate) / (2 * rate);
                otable.style.transform = `scale(${rate}) translate(-${ewidth}px, -${eheight}px)`;
                otablewrapper.style.height = aheight * rate + 'px';
                otablewrapper.style.overflow = 'hidden';
                this.showTable = false;
            })
        },
        destroyed(){
            
        },
    }
</script>

<style lang="less">
.m-table {
    overflow-x: auto;
    table {
        table-layout: fixed;
        thead {
            position: -webkit-sticky;
            position: sticky;
            top: 0;
            tr {
                display: inline-block;
                height: 88px;
                line-height: 88px;
                font-weight: 400;
                padding-left: 32px;
                padding-right: 32px;
                th div {
                    box-sizing: border-box;
                    padding-right: 32px;
                    &.m-head-rank {
                        position: relative;
                        padding-right: 54px;
                        .m-rank-base {
                            position: absolute;
                            width: 14px;
                            height: 30px;
                            top: 50%;
                            right: 34px;
                            padding: 0;
                            background-image: url('../../assets/images/icon_t.png');
                            background-repeat: no-repeat;
                            background-size: 100% 100%;
                            transform: translateY(-50%);
                            &.m-rank-up {
                                background-image: url('../../assets/images/icon_t_up.png');
                            }
                            &.m-rank-down {
                                background-image: url('../../assets/images/icon_t_down.png');
                            }
                        }
                        // &::before {
                        //     content: '';
                        //     position: absolute;
                        //     top: 20px;
                        //     right: 32.5px;
                        //     width: 0;
                        //     height: 0;
                        //     border-width: 11px 8px;
                        //     border-style: solid;
                        //     border-color: transparent transparent #cccccc transparent;
                        // }
                        // &::after {
                        //     content: '';
                        //     position: absolute;
                        //     top: 48.5px;
                        //     right: 32.5px;
                        //     width: 0;
                        //     height: 0;
                        //     border-width: 11px 8px;
                        //     border-style: solid;
                        //     border-color: #cccccc transparent transparent transparent;
                        // }
                        // &.m-head-up {
                        //     &::before { 
                        //         border-bottom-color: #e93030;
                        //         right: 32px;
                        //     }
                        // }
                        // &.m-head-down {
                        //     &::after { 
                        //         border-top-color: #e93030;
                        //         right: 32px;
                        //     }
                        // }
                    }
                }
                th:last-child div.m-head-rank {
                    padding-right: 22px;
                    .m-rank-base {
                        right: 2px;
                    }
                    // &::before {
                    //     right: 0px;
                    // }
                    // &::after {
                    //     right: 0px;
                    // }
                }
            }
        }
        tbody {
            tr {
                position: relative;
                display: inline-block;
                box-sizing: border-box;
                padding: 24px 0 0 32px;
                
                td .m-tbody-td{
                    border-bottom: 2px solid rgba(0, 0, 0, 0.04);
                    padding-bottom: 22px;
                    padding-right: 32px;
                    white-space: nowrap;
                    box-sizing: border-box;
                    .m-tbody-td-first {
                        font-family: PingFangSC-Regular;
                        font-size: 28px;
                        color: #323232;
                        line-height: 40px;
                        font-weight: 400;
                        margin-bottom: 4px;
                        height: 40px;
                        &.red {
                            color: #FF330A;
                        }
                        &.green {
                            color: #00BB1D;
                        }
                    }
                    .m-tbody-td-second {
                        height: 32px;
                        line-height: 32px;
                        font-weight: 400;
                        &.m-suit {
                            box-sizing: border-box;
                            width: 56px;
                            background: #F6F6F6;
                            border: 1px solid rgba(0, 0, 0, 0.04);
                            border-radius: 8px;
                            margin-left: 15px;
                            line-height: 30px;
                        }
                    }
                }
                td:last-child .m-tbody-td {
                    padding-right: 0;
                }
                td:first-child .m-tbody-td-second {
                    span {
                        display: inline-block;
                        padding: 0 4px;
                        height: 32px;
                        line-height: 32px;
                        border-radius: 8px;
                        margin-right: 8px;
                    }
                }
                &.low-color {
                    background-image: linear-gradient(270deg, rgba(0,187,29,0.00) 0%, rgba(0,187,29,0.10) 100%);
                    z-index: -1;
                    .specical-color {
                        background: #00CC22;
                    }
                }
                &.middle-color {
                    background-image: linear-gradient(270deg, rgba(255,247,230,0.00) 0%, #FFF7E6 100%);
                    z-index: -1;
                    .specical-color {
                        background: #FFAA00;
                    }
                }
                &.high-color {
                    background-image: linear-gradient(270deg, rgba(255,238,235,0.00) 0%, #FFEEEB 100%);
                    z-index: -1;
                    .specical-color {
                        background: #FF330A;
                    }
                }
                .low-color-em {
                    background: #00CC22;
                }
                .middle-color-em {
                    background: #FFAA00;
                }
                .high-color-em {
                    background: #FF330A;
                }
            }
        }
        thead tr th, tbody tr td {
            text-align: right;
        }
        thead tr th:first-child div, tbody tr td:first-child .m-tbody-td {
            width: 256px;
            text-align: left;
        }
        thead tr th:nth-child(2) div, tbody tr td:nth-child(2) .m-tbody-td {
            width: 120px;
        }
        thead tr th:nth-child(3) div, tbody tr td:nth-child(3) .m-tbody-td {
            width: 107px;
        }
        thead tr th:nth-child(4) div, tbody tr td:nth-child(4) .m-tbody-td {
            width: 172px;
        }
        thead tr th:nth-child(5) div, tbody tr td:nth-child(5) .m-tbody-td {
            width: 107px;
        }
        thead tr th:nth-child(6) div, tbody tr td:nth-child(6) .m-tbody-td {
            width: 172px;
        }
        thead tr th:nth-child(7) div, tbody tr td:nth-child(7) .m-tbody-td {
            width: 152px;
        }
        thead tr th:nth-child(8) div, tbody tr td:nth-child(8) .m-tbody-td {
            width: 192px;
        }
        thead tr th:nth-child(9) div, tbody tr td:nth-child(9) .m-tbody-td {
            width: 192px;
        }
    }
    .m-table-progress {
        position: relative;
        display: inline-block;
        width: 84px;
        height: 8px;
        background: #F6F7F8;
        border-radius: 20px;
        em {
            position: absolute;
            top: 0; 
            left: 0;
            height: 8px;
            border-radius: 20px;
        }
    }
    .isFixed {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10;
    }
}
.m-index-list {

}
</style>
